// extracted by mini-css-extract-plugin
export default {"container":"Wj-z","blurb":"Xj-z","links":"Yj-z"};